import type ItinerarySearchForm from '@search/ItinerarySearchForm';

export function useCurrentSearchForm<
    T extends ItinerarySearchForm = ItinerarySearchForm,
>() {
    const searchFormStore = useSearchFormStore();
    return computed(() => searchFormStore.currentSearchForm<T>());
}
